import React from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Course from "../Courses/course";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "block",
    height: "100%",
  },
  title: { color: theme.app.labelColor, padding: "8px" },
  listWrapper: {
    padding: "0",
  },
}));

const UpcomingCourses = (props) => {
  const { upcoming, manages, book } = props;
  const classes = useStyles();
  const language = useSelector((state) => state.language);

  return (
    <div className={classes.container}>
      <Typography
        variant="h2"
        className={classNames(classes.title, "upcoming__subheader")}
      >
        {language.upcomingCourses}
      </Typography>
      <div>
        <ul className={classes.listWrapper}>
          {upcoming &&
            upcoming.map((x, i) => {
              return (
                <Course
                  key={x.id}
                  course={x}
                  book={book}
                  manages={manages}
                  showTooltip={true}
                  index={i}
                />
              );
            })}
        </ul>
      </div>
    </div>
  );
};

export default UpcomingCourses;
